import { Component, OnInit } from '@angular/core';
import { DepartmentService } from '../../services/jrni/department.service';
import { AlertService } from '../../_alert';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatastoreService } from '../../services/datastore.service';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import * as _ from 'lodash';
import { ApiService } from '../../services/jrni/api.service';
import { environment } from '../../../environments/environment';
import { interval } from 'rxjs';

@Component({
  selector: 'app-departments',
  templateUrl: './departments.component.html',
  styleUrls: ['./departments.component.scss'],
})
export class DepartmentsComponent implements OnInit {
  childrenDepartments: [];
  pageTitle: string;
  faChevronRight = faChevronRight;
  guidanceMsg: string;
  guidanceMsgPermits: string;
  childRows: any[];
  subscription: any;
  display_location_and_services_page_permit_guidance: boolean;

  constructor(
    private departmentService: DepartmentService,
    private datastoreService: DatastoreService,
    protected alertService: AlertService,
    private router: Router,
    private translateService: TranslateService,
    private spinner: NgxSpinnerService,
    private apiService: ApiService
  ) { }

  ngOnInit() {
    this.scrollToTop();
    this.spinner.show();
    this.getDepartments();
  }

  async getDepartments() {
    // reset the restricted booking
    this.datastoreService.isRestrictedBooking = false;
    this.datastoreService.isRestrictedAsbestosBooking = false;
    this.datastoreService.isCommercialBooking = false;

    let parentDepartment = await this.departmentService.getParentDepartment();
    this.datastoreService.parentDepartment = parentDepartment;

    const pId = parentDepartment.id;
    const pClient = parentDepartment.self.split('://')[1].split('.')[0];
    const token: any = await this.apiService.getToken(pClient, pId);
    if (token) {
      environment.clientToken = token.token;
    }
    const config = await this.apiService.getConfig(pClient, pId);
    this.datastoreService.config = config;
    console.log("this.config",this.datastoreService.config)
    if (parentDepartment && parentDepartment.extra) {
      this.pageTitle = parentDepartment.extra.location_page_title;
      this.guidanceMsg = parentDepartment.extra.location_page_guidance_text;
      this.guidanceMsgPermits = parentDepartment.extra.location_and_services_page_permit_guidance_text;
      this.display_location_and_services_page_permit_guidance = parentDepartment.extra.display_location_and_services_page_permit_guidance === "Yes";
    }

    this.datastoreService.parentDepartment = parentDepartment;

    this.datastoreService.extra = parentDepartment.extra;
    let departments = await this.departmentService.getChildDepartments(
      parentDepartment
    );
    let sortedDepartments = [];
    sortedDepartments = _.orderBy(departments, ['name', 'asc']) as [];
    this.spinner.hide();
    sortedDepartments = sortedDepartments.filter((x) => x.extra.display_location_on_locations_page !== "No")
    //@ts-ignore
    this.childrenDepartments = sortedDepartments;
    this.childRows = [];
    const chunkSize = 3;
    for (let i = 0; i < sortedDepartments.length; i += chunkSize) {
      const chunk = sortedDepartments.slice(i, i + chunkSize);
      this.childRows.push(chunk);
    }
    // while(true){

    // }
    const source = interval(100);
    this.subscription = source.subscribe((val) => {
      console.log('sup');
      let count = 0;
      let all = this.childrenDepartments.length;
      let maxHeight = 0;
      let childRowsMaxHeights = [];
      for (let i = 0; i < this.childRows.length; i++) {
        let row = this.childRows[i];
        childRowsMaxHeights.push(0);
        for (let locations of row) {
          const el = document.getElementById(locations.id);
          if (el) {
            count++;
            if (maxHeight < el.offsetHeight) {
              maxHeight = el.offsetHeight
            }
          }
        }
        childRowsMaxHeights[i] = maxHeight
        maxHeight = 0
      }
      if (count >= all) {
        for (let i = 0; i < this.childRows.length; i++) {
          let row = this.childRows[i];
          for (let locations of row) {
            const el = document.getElementById(locations.id);
            el.style.height = `${childRowsMaxHeights[i]}px`;
          }
        }
        this.subscription.unsubscribe();
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  selectDepartment(department) {
    this.departmentService.set(department);
    this.datastoreService.selectedDepartment = department;
    this.departmentService.setLocation(department);
    // If the department has the setting required login then navigate to login else to services page
    // if (department.hasOwnProperty('extra') && department.extra.hasOwnProperty('login_required')) {
    //   if (department.extra.login_required.toLowerCase() === 'yes') {
    //     this.router.navigate(['/login']);
    //   } else {
    //     if (department.extra.service_or_location_first.toLowerCase() === 'service') {
    //       this.router.navigate(['/services']);
    //     }
    //   }
    // }
  }


  continue(goTO) {
    this.router.navigate([goTO]);
  }

  // scroll to the top of the page
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }
}
